import * as React from "react";
import "../blobs/BlobsComponent.css";
export const BlobsComponent = () => {
  return (
    <>
     
    </>
  );
};
